import React from "react";
import { FrontColors } from "../../../../models/FrontColors";
import { FrontFontSizes } from "../../../../models/FrontFontSizes";
import { FrontSpacing } from "../../../../models/FrontSpacing";
import { Background } from "../../../BuildingBlocks/Background";
import UnstyledTextAreaComponent from "../../../UnstyledTextAreaComponent/UnstyledTextAreaComponent";

export const FPTextArea = (props: React.PropsWithChildren<{
    coloursInverted?: boolean;
    flatEdge?: boolean;
    value: string;
    placeholder?: string;
    autoFocus?: boolean;
    displayError?: boolean;
    onChange: (value: string) => void;
}>): JSX.Element => {
    const coloursInverted = props.coloursInverted || false;

    const flatEdge = props.flatEdge || false;

    const placeholder = props.placeholder || "";

    const displayError = props.displayError || false;

    const textAreaBackgroundColour =
        coloursInverted
            ? FrontColors.NEUTRAL_18
            : FrontColors.PROBATE_0;

    const borderColour =
        coloursInverted
            ? FrontColors.NEUTRAL_18
            : FrontColors.PROBATE_0;

    const textAreaTextColour =
        displayError ? FrontColors.ERROR_FIREBRICK_10
        : coloursInverted ? FrontColors.NEUTRAL_0
        : FrontColors.NEUTRAL_13;

    const borderRadius =
        flatEdge
            ? "5px 0px 0px 5px"
            : "5px";

    return <Background
        display="flex"
        borderRadius={borderRadius}
        borderDefinition={`solid 2px ${borderColour}`}
        color={textAreaBackgroundColour}
        height="100%"
        minHeight="96px"
        padding={`${FrontSpacing.SMALL_1} ${FrontSpacing.SMALL_3}`}
        alignItems="space-between"
    >
        <UnstyledTextAreaComponent
            value={props.value}
            displayError={false}
            autoFocus={props.autoFocus || false}
            placeholder={placeholder}
            className={`fs-exclude front-probate-text-area__text-area ${
                displayError ? "front-probate-text-area__text-area--error"
                : coloursInverted ? "front-probate-text-area__text-area--inverted"
                : ""
            }`}
            style={{
                width: "100%",
                WebkitAppearance: "none",
                appearance: "none",
                background: "none",
                outline: "none",
                border: "none",
                fontSize: FrontFontSizes.SMALL,
                fontFamily: "Roboto Slab",
                color: textAreaTextColour,
            }}
            onChange={props.onChange}
        />
    </Background>;
};
